function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Button as MuiButton, styled } from "@mui/material";
import { useCamelCase } from "@vestwell-frontend/hooks";
import { forwardRef } from "react";
import * as React from "react";
import { Link } from "react-router-dom";
var StyledButton = styled(MuiButton, {
    shouldForwardProp: function(prop) {
        return prop !== 'loading';
    }
})(function(_param) {
    var color = _param.color, props = _object_without_properties(_param, [
        "color"
    ]);
    return {
        backgroundColor: props.loading ? props.theme.palette.grey700.main : props.disabled && props.variant === 'inline' ? 'transparent' : undefined,
        color: props.loading ? 'transparent !important' : props.variant === 'inline' ? props.theme.palette[color !== null && color !== void 0 ? color : 'primary'].main : undefined
    };
});
var LoadingIndicator = styled(CircularProgress, {
    shouldForwardProp: function(prop) {
        return prop !== 'loading';
    }
})(function(props) {
    return {
        color: props.theme.palette.action.disabled,
        position: 'absolute'
    };
});
export var Button = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var _param_color = _param.color, color = _param_color === void 0 ? 'primary' : _param_color, _param_variant = _param.variant, variant = _param_variant === void 0 ? 'contained' : _param_variant, props = _object_without_properties(_param, [
        "color",
        "variant"
    ]);
    var dataTestId = useCamelCase(typeof props.children === 'string' ? props.children : '');
    return /*#__PURE__*/ _jsxs(StyledButton, _object_spread_props(_object_spread({}, props), {
        color: color,
        component: props.to ? Link : undefined,
        "data-component": props['data-component'] || 'button',
        "data-disabled": !!props.disabled || !!props.loading,
        "data-testid": props['data-testid'] || dataTestId,
        disabled: !!props.disabled || !!props.loading,
        ref: ref,
        to: props.to,
        variant: variant,
        children: [
            !!props.loading && /*#__PURE__*/ _jsx(LoadingIndicator, {
                color: "inherit",
                size: 16
            }),
            props.children
        ]
    }));
});
Button.displayName = 'Button';

//# sourceMappingURL=Button.js.map